module.exports = __webpack_public_path__ + "static/menu-contacts-46a169aec3efa2a61769c4f4db41fc07.jpg";